import axios from "axios/index";

export function updatePosition(position) {
  return axios.put(`/cart/positions/${position.id}.json`, {amount: position.amount })
}

export function addToCart(product, amount) {
  return axios.post(`/cart/positions.json`, {product_id: product.id, amount: amount })
}
